import { Body2, Box, Flex, Toggletip } from '@sainsburys-tech/fable'
import moment from 'moment'
import React from 'react'

import { getColleagueName } from '../../../utils/colleagueDetails'

const editedForecastMessage = (
  colleageName: string,
  date: string,
  message: string,
) => (
  <>
    Last edited by:
    <br />
    {colleageName} {date}.<br />
    <br />
    {message}
  </>
)

export const LastEditedTooltip = (
  username: string,
  date: Date,
  baseForecast: number,
  message: string,
) => (
  <div className='c-common-border c-common-inline'>
    <Flex alignItems='center' justifyContent='center' gap='sm'>
      <Toggletip
        testid='last-edited-tooltip'
        label='Last edited'
        message={editedForecastMessage(
          getColleagueName(username).fullName,
          moment(date).format('[at] HH:mm [on] DD/MM/YYYY'),
          message,
        )}
        position='top'
        className='c-lastedited-tooltip'
      />

      <Box className='c-common-inline c-lastedited-tooltip-initials'>
        <Body2>
          {getColleagueName(username).initials} ({baseForecast})
        </Body2>
      </Box>
    </Flex>
  </div>
)
